import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import { showLoader, hideLoader } from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'
import getUserRepairWorkshops from '../../services/repairshop/getUserRepairWorkshops'

export function * fetchUserRepairWorkshopsCombo () {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const repairWorkshopsCombo = yield call(getUserRepairWorkshops, auth.token)
    yield put(fetchCombosSuccess({ repairWorkshopsCombo }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchUserRepairWorkshopsCombo () {
  yield takeLatest(combosActionTypes.FETCH_USER_REPAIR_WORKSHOPS_COMBO, fetchUserRepairWorkshopsCombo)
}
